<template>
    <span v-show="message" class="text-xs text-gray-600 dark:text-gray-400">
        {{ message }}
    </span>
</template>

<script>
    import { defineComponent } from 'vue'

    export default defineComponent({
        props: ['message']
    })
</script>
